(function() {
  "use strict";

  angular
    .module("app")
    .controller("ActionsBarController", [
      "$scope",
      "$location",
      "$http",
      ActionsBarController
    ]);

  function ActionsBarController($scope, $location, $http) {
    $scope.currentURL = $location;
    $scope.imageDownload = {
      inProgress: false,
      error: false
    };

    function getEncodedUrl() {
      return encodeURIComponent($scope.currentURL.absUrl());
    }

    $scope.getEncodedURL = getEncodedUrl;

    var selectedAssetsString = function() {
      if ($scope.state && $scope.state.selectedAssets) {
        var assetsByName = $scope.state.selectedAssets
          .map(function(assetId) {
            var assetParents = $scope.findAssetParent(assetId);
            if (assetParents.length > 1) {
              return (
                $scope.state.assetsById[assetParents[1]].name.trim() +
                "/" +
                $scope.state.assetsById[assetId].name.trim()
              );
            }
            else {
              return $scope.state.assetsById[assetId].name.trim();
            }
          })
          .join("|");

        return assetsByName;
      }
      else {
        return "";
      }
    };

    $scope.assetRawDataUrl = function() {
      return $scope.state && $scope.state.selectedIndicator
        ? "/AssetRawData.axd?ind=" +
            $scope.state.selectedIndicator.id +
            "&assets=" +
            encodeURIComponent(selectedAssetsString())
        : "";
    };

    $scope.$watch(
      "state.selectedCommunities",
      function(oldVal, newVal) {
        if (oldVal === newVal) {
          return false;
        }
        $location.search(
          "communities",
          $scope.state.selectedCommunities.communities.join("|")
        );
      },
      true
    );

    $scope.retryCount = 0;
    $scope.downloadImage = function() {
      var url =
        "/image/generate?width=1200&wait=true&url=" +
        getEncodedUrl() +
        "%26cap%3Dtrue";
      $scope.imageDownload.inProgress = true;
      $scope.imageDownload.error = false;

      $http({
        url: url,
        method: "GET",
        responseType: "arraybuffer"
      })
        .success(function(data, status, headers, config) {
          // TODO when WS success
          var file = new Blob([data], {
            type: "image/png"
          });

          var fileName = "CCC-Image.png";

          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveBlob(file, fileName);
          }
          else {
            //trick to download store a file having its URL
            var fileURL = URL.createObjectURL(file);
            var tempLink = document.createElement("a");
            tempLink.href = fileURL;
            tempLink.target = "_blank";
            tempLink.download = fileName;
            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);
          }
          $scope.imageDownload.inProgress = false;
        })
        .error(function(data, status, headers, config) {
          if ($scope.retryCount >= 3) {
            $scope.retryCount = 0;
            $scope.imageDownload.inProgress = false;
            $scope.imageDownload.error = true;
            console.log(data, status, headers, config);
          }
          else {
            $scope.retryCount += 1;
            $scope.downloadImage();
          }
        });
    };
  }
})();
